import React from 'react'
import { Link } from 'react-router-dom';
import { Hexagon } from 'react-feather';
import { TbCameraPlus, TbSitemap } from 'react-icons/tb';
import { LuLayers } from 'react-icons/lu';

export default function Feature() {
  return (
    <div className="container md:mt-24 mt-16">
      <div className="grid grid-cols-1 text-center">
        <h3 className="mb-4 md:text-3xl text-2xl md:leading-snug leading-snug font-semibold">Integrating AI into Solar Exchange NFT Marketplace</h3>

        <p className="text-slate-400 max-w-xl mx-auto">Enhancing User Experience and Expanding Potential</p>
        <p className="text-slate-400 max-w-xl mx-auto">Integrating artificial intelligence (AI) into the Solar Exchange NFT Marketplace will bring significant breakthroughs, enhancing user experience and opening up new opportunities</p>
      </div>

      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-10 gap-[30px]">

        <div className="group relative lg:px-6 mt-4 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center">
          <div className="relative overflow-hidden text-transparent -m-3">
            <Hexagon className="w-28 fill-violet-600/5 mx-auto rotate-[30deg]"></Hexagon>
            <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto rounded-xl transition duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
              <TbSitemap />
            </div>
          </div>

          <div className="mt-6">
            <Link to="#" className="text-lg h5 font-semibold transition duration-500 ease-in-out hover:bg-tone">Thriving NFT marketplace.</Link>
            <p className="text-slate-400 transition duration-500 ease-in-out mt-3">Create, buy, and sell unique digital artworks.</p>
          </div>
        </div>
        <div className="group relative lg:px-6 mt-4 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center">
          <div className="relative overflow-hidden text-transparent -m-3">
            <Hexagon className="w-28 fill-violet-600/5 mx-auto rotate-[30deg]"></Hexagon>
            <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto rounded-xl transition duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
              <LuLayers />
            </div>
          </div>

          <div className="mt-6">
            <Link to="#" className="text-lg h5 font-semibold transition duration-500 ease-in-out hover:bg-tone">Market analysis tools</Link>
            <p className="text-slate-400 transition duration-500 ease-in-out mt-3">AI-powered tools to help you make informed investment decisions.</p>
          </div>
        </div>
        <div className="group relative lg:px-6 mt-4 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center">
          <div className="relative overflow-hidden text-transparent -m-3">
            <Hexagon className="w-28 fill-violet-600/5 mx-auto rotate-[30deg]"></Hexagon>
            <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto rounded-xl transition duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
              <TbCameraPlus />
            </div>
          </div>

          <div className="mt-6">
            <Link to="#" className="text-lg h5 font-semibold transition duration-500 ease-in-out hover:bg-tone">Attractive promotions</Link>
            <p className="text-slate-400 transition duration-500 ease-in-out mt-3">Enjoy numerous benefits when trading on Solar Exchange.</p>
          </div>
        </div>

      </div>
    </div>
  )
}
